export default "__VITE_ASSET__C_gB9kzK__"